import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { CmsProductCarouselComponent, Product, ProductService, isNotUndefined } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData, ProductCarouselComponent } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-custom-product-carousel',
  templateUrl: './custom-product-carousel.component.html',
  styleUrls: ['./custom-product-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomProductCarouselComponent extends ProductCarouselComponent {
  @Input() item: CmsProductCarouselComponent;
  animation = 'swipe';
  component$: Observable<CmsProductCarouselComponent> = this.componentData.data$.pipe(
    filter(Boolean),
  );

  constructor(
    protected componentData: CmsComponentData<CmsProductCarouselComponent>,
    protected productService: ProductService,
    protected breakpointService: BreakpointService,
    protected cd: ChangeDetectorRef,
  ) {
    super(componentData, productService);
  }

  items$: Observable<Observable<Product>[]> = this.component$.pipe(
    map((data) => data.productCodes?.trim().split(' ') ?? []),
    map((codes) =>
        codes.map((code) => this.productService.get(code, this.PRODUCT_SCOPE)),
      map(filter(isNotUndefined))
    )
  );

  isMobile(): Observable<boolean> {
    return this.breakpointService?.isDown(BREAKPOINT.sm);
  }
}
